import { render, staticRenderFns } from "./DedicationSaleView.vue?vue&type=template&id=da6a0008&scoped=true&"
import script from "./DedicationSaleView.vue?vue&type=script&lang=js&"
export * from "./DedicationSaleView.vue?vue&type=script&lang=js&"
import style0 from "./DedicationSaleView.vue?vue&type=style&index=0&id=da6a0008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6a0008",
  null
  
)

export default component.exports